import { gql } from 'graphql.macro';

export const dexisTokenLoginTemplate = gql`
    mutation dexisTokenLogin($authCode: String!) {
        dexisTokenLogin(authCode: $authCode)
    }
`;

export const threeShapeTokenLoginTemplate = gql`
    mutation threeShapeTokenLogin($authCode: String!) {
        threeShapeTokenLogin(authCode: $authCode)
    }
`;

export const meditTokenLoginTemplate = gql`
    mutation meditTokenLogin($authCode: String!, $stateFromMedit: String!) {
        meditTokenLogin(authCode: $authCode, stateFromMedit: $stateFromMedit)
    }
`;

export const pandaTokenLoginTemplate = gql`
    mutation pandaTokenLogin($authCode: String!) {
        pandaTokenLogin(authCode: $authCode)
    }
`;

export const pandaEuTokenLoginTemplate = gql`
    mutation pandaEuTokenLogin($authCode: String!) {
        pandaEuTokenLogin(authCode: $authCode)
    }
`;

export const dsCoreTokenLoginTemplate = gql`
    mutation dsCoreTokenLogin($authCode: String!) {
        dsCoreTokenLogin(authCode: $authCode)
    }
`;

export const doNotImportScannerCaseTemplate = gql`
    mutation doNotImportScannerCase($caseId: MongoDbObjectId!) {
        doNotImportScannerCase(caseId: $caseId) {
            _id
            orderStatus
        }
    }
`;

export const startFileImportBackgroundProcessTemplate = gql`
    mutation startFileImportBackgroundProcess($caseId: MongoDbObjectId!) {
        startFileImportBackgroundProcess(caseId: $caseId)
    }
`;

export const triggerScannerCaseSyncTemplate = gql`
    mutation triggerScannerCaseSync {
        triggerScannerCaseSync {
            dexis {
                status
                statusUpdated
            }
            medit {
                status
                statusUpdated
            }
            panda {
                status
                statusUpdated
            }
            pandaEu {
                status
                statusUpdated
            }
            threeShape {
                status
                statusUpdated
            }
            dsCore {
                status
                statusUpdated
            }
        }
    }
`;

export const createDraftScannerCaseOrderForDentistTemplate = gql`
    mutation createDraftScannerCaseOrderForDentist($caseId: MongoDbObjectId!) {
        createDraftScannerCaseOrderForDentist(caseId: $caseId)
    }
`;

export const attachScannerCaseToOrderTemplate = gql`
    mutation attachScannerCaseToOrder($orderId: MongoDbObjectId!, $scannerCaseId: MongoDbObjectId!) {
        attachScannerCaseToOrder(orderId: $orderId, scannerCaseId: $scannerCaseId)
    }
`;

export const unlinkAttachedScannerCaseTemplate = gql`
    mutation unlinkAttachedScannerCase($orderId: MongoDbObjectId!, $scannerCaseId: MongoDbObjectId!) {
        unlinkAttachedScannerCase(orderId: $orderId, scannerCaseId: $scannerCaseId)
    }
`;
